const klassifikation = [
	"Ausbruchsgrube",
	"Abbruchhorizont",
	"Befund, unspezifiziert",
	"Baugrube",
	"Brandgrab",
	"Bauhorizont",
	"Brunnen",
	"Brandschicht",
	"Brandstelle",
	"Befund, unsicher",
	"Estrich",
	"Fund, unspezifiziert",
	"Fussboden",
	"Fundament",
	"Feuerstelle",
	"Grube",
	"Grubenkomplex",
	"Grabhuegel",
	"Grab",
	"Graebchen",
	"Gebaeude",
	"Geologie",
	"Grabgrube",
	"Grubenhaus",
	"Graben",
	"Gewoelbe",
	"Herd",
	"Herdstelle",
	"Kanal",
	"Koerpergrab",
	"Keller",
	"Laufhorizont",
	"Latrine",
	"Mauer",
	"aufgehendes Mauerwerk",
	"Mauerwerk",
	"Ofen",
	"Pfostengrube",
	"Pflaster",
	"Planierschicht",
	"Rollierung",
	"Pfostenstandspur",
	"Schicht",
	"Stoerung",
	"Steinsetzung",
	"Tenne",
	"Verfuellung",
	"Wandgraebchen",
	"Ziegelmauer"
];

export default klassifikation;
